import { useStaticQuery, graphql } from 'gatsby';
import type { ISiteMetadata } from '@klaviyo-mkt/marketing-cms/src/staticTypes';

export const useSiteMetadataQuery = () => {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          langCode
          pathPrefix
          siteParentUrl
          siteUrl
        }
      }
    }
  `);

  return data?.site?.siteMetadata || {
    langCode: 'en-US',
    pathPrefix: '',
    siteParentUrl: '',
    siteUrl: '',
  } satisfies ISiteMetadata;
};
